/**
 * SEO Redirect Map — Phase 1
 * 
 * 16 redirects: clear synonym/modifier duplicates with no independent content value.
 * Client-side via <Navigate replace />.
 * 
 * PRODUCTION NOTE: Server-side 301 redirects are recommended for full SEO benefit.
 * Configure in Vercel (vercel.json), Netlify (_redirects), or hosting provider.
 */
export const redirectMap: Record<string, string> = {
  // Compression synonyms → /comprimir-imagen (top-level landing page)
  'comprimir-imagen': '/comprimir-imagen',
  'comprimir-foto': '/comprimir-imagen',
  'comprimir-imagen-online': '/comprimir-imagen',
  'comprimir-fotos-online': '/comprimir-imagen',
  'comprimir-foto-online': '/comprimir-imagen',
  
  'reducir-peso-imagen': '/comprimir-imagen',
  'reducir-tamano-imagen': '/comprimir-imagen',
  'reducir-peso-foto': '/comprimir-imagen',

  // Format-specific synonym
  'comprimir-imagen-jpg': 'comprimir-jpg',

  // foto/imagen duplicates (document resize)
  'redimensionar-foto-pasaporte': 'redimensionar-imagen-pasaporte',
  'redimensionar-foto-carnet': 'redimensionar-imagen-carnet',

  // reducir-foto-* template-generated (no differentiated content)
  'reducir-foto-50kb': 'reducir-imagen-50kb',
  'reducir-foto-300kb': 'reducir-imagen-300kb',
  'reducir-foto-500kb': 'reducir-imagen-500kb',

  // Tool synonym duplicates
  'recortar-imagen-online': 'recortar-imagen',
  'girar-foto': 'rotar-imagen',
};

/** Set for O(1) lookup */
export const redirectSlugs = new Set(Object.keys(redirectMap));
